module.exports = __webpack_public_path__ + "img/up-to-line.15498061.svg";